import { useState } from 'react';

export function useEditableThemeFields(
  initialValue, 
  patchEndpoint, 
  fieldName, 
  infoThemeId, 
  axiosInstance, 
  setInfoTheme
) {
  
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(true);
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    setIsSaved(false);
    setIsError(false);
    setInfoTheme((prev) => ({
      ...prev,
      [fieldName]: e.target.value
    }));
  };

  const handleSave = async (value) => {
    const trimmed = value.trim();
    if (!trimmed.length) return;

    setIsError(false);
    setIsSaving(true);
    try {
      const response = await axiosInstance.patch(
        `/knovia/infoTheme/${infoThemeId}/${patchEndpoint}`,
        { [fieldName]: trimmed }
      );
      setInfoTheme((prev) => ({
        ...prev,
        ...response.data
      }));
      setIsSaved(true);
    } catch (err) {
      setIsError(true);
      console.error(err);
    } finally {
      setIsSaving(false);
    }
  };

  return {
    isSaving,
    isSaved,
    isError,
    handleChange,
    handleSave,
  };
}
